import { render, staticRenderFns } from "./StockCategoryUnit.vue?vue&type=template&id=54765c3a&scoped=true&lang=pug"
import script from "./StockCategoryUnit.vue?vue&type=script&lang=js"
export * from "./StockCategoryUnit.vue?vue&type=script&lang=js"
import style0 from "./StockCategoryUnit.vue?vue&type=style&index=0&id=54765c3a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54765c3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VCombobox,VContainer,VDialog,VIcon,VRow})
